import { get, post } from '@/utils/request';

export const getUserBankInfo = () => {
  return get('/api/v1/business/user_bank_info');
};

export const applySettle = (params) => {
  return post('/api/v1/business/apply_settle', params);
};

export const settlePreview = (params) => {
  return get('/api/v1/business/settle_preview', params);
};

export const teamPerformanceVisible = () => {
  return get('/api/v1/business/team_performance_visible');
};

export const teamPerformances = (params) => {
  return get('/api/v1/business/team_performances', params);
};

export const syncSettleOrder = (params) => post('/api/v1/business/sync_settle_order', params);
